import { Component } from 'react';
import { Button, Card, Col, Drawer, Empty, Layout, message, Modal, PageHeader, Row, Select, BackTop, Tooltip } from 'antd';
import { ArrowsAltOutlined, ClearOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { BiTargetLock } from 'react-icons/bi';
import { ImLocation } from 'react-icons/im';
import ReactGA from 'react-ga';
import {checkForIframe, filterItems} from '../Utils';
import ListItem from './ListItem';

const { Content, Header, Footer } = Layout;

export class Browser extends Component {

  constructor(props) {
    super();
    //default state
    this.state = {
      items: [],
      currentItems: [],
      currentItem: null,
      currentFilters: [],
      filtersVisible: false,
      focusFilterEnabled: true,
      inIFrame: false,
      locationMenuData: []
    }
    //configure popups
    message.config({
      top: 20,
      duration: 1.5,
      maxCount: 1,
    });
  }

  //MOUNT
  async componentDidMount() {
    //load data here
    try {
      //load json file using fetch api
      const dataAsString = await fetch('./data.json');
      //convert text to json
      const json = await dataAsString.json();

      const locationMenuData = this.generateLocationMenuData(json);

      const inIframe = checkForIframe();
      //add contents to state under items prop
      this.setState({items: json, currentItems: json, inIframe, locationMenuData });
    } catch(err) {
      console.log(err);
      console.error("Some error occured parsing or loading the JSON");
    }
  }

  generateLocationMenuData(items) {
    
    //get a unique list of all locations
    return items.reduce((acc, item) => {
      //item.locations = []
      item.locations.forEach(location => {

        //make shortcut to category
        const category = location[0];
        
        //if category doesn't exist
        if (!acc.find(entry => entry.label === category)) { 
          //one doesn't exist, create one
          acc.push({
            label: category,
            value: category,
            children: []
          });
        }

        //at this point, a category definitely exists
        //find category Objects to populate with subitems

        const categoryObject = acc.find(entry => entry.label === category);

        const item = location[1];
        
        if (!categoryObject.children.find(itemObj => itemObj.label === item)) {
          //doesn't exist
          categoryObject.children.push({
            label: item,
            value: item
          })
        };
        
      });
      return acc;
    }, []);
  }

  handleChangeFilter = (prop, value) => {
    //deconstruct props from state
    const { items, currentFilters } = this.state;
    //remove any current 'cortexLocations' filters
    const newFilters = [...currentFilters].filter(filter => filter.prop !== prop);
    //if a value is not null, add 'use' filter
    if (value != null) newFilters.push({ prop, values: [value] });
    console.log(newFilters);
    //get items matching the filtering
    const filteredItems = filterItems([...items], newFilters);
    //update state
    this.setState({currentItems: filteredItems, currentFilters: newFilters});
  }
  handleResetFilters = () => {  
    message.success("All filters cleared");
    const { items } = this.state;
    this.setState({currentItems: items, currentFilters: []});
  }
  //HANDLERS: SHOW / HIDE DETAILS
  handleShowPreview = (item) => { 
    const { embed, preview } = item;
    if (embed == null) {
      if (preview != null) {
        window.open(preview)
      }
      return;
    }
    this.setState({currentItem: item}) 
    //GA tracking on modal view
    ReactGA.pageview(`/${item.id}`);
  }
  handleHidePreview = () => { this.setState({currentItem: null}) }
  
  //RENDERERS: ITEMS
  renderItems() {
    let { currentItems } = this.state;
    //check if items exist
    if (currentItems.length <= 0) {
      return (
        <Col xs={24}>
          <Card>
            <Empty description="No items match the selected filters" />
          </Card>
        </Col>
      )
    }
    return currentItems.map(item => <ListItem key={item.id} item={item} onClickPreview={this.handleShowPreview} />)
  
  }
  //RENDERERS: LOCATION MENU
  renderLocationMenu() {
    let { locationMenuData } = this.state;

    const { Option,OptGroup } = Select;

    return (
      <Select defaultValue={null} style={{width: '100%'}} onChange={ value => this.handleChangeFilter('locations', value) } value={this.getFilterValue('locations')}>
        <Option key="all" value={null}>All</Option>
        {
          /* Get all categories */
          locationMenuData.map(i => {
            return (
              <OptGroup key={i.value} label={i.label}>
                {
                  /* Get all other items */
                  i.children.map(c => {
                    return <Option key={c.value} value={c.value}>{c.label}</Option>
                  })
                }
              </OptGroup>
            )
          })
        }
      </Select>
    )
  }

  //RENDERERS: MAIN
  render() {
    const { currentFilters, currentItems, currentItem, items, filtersVisible, focusFilterEnabled, inIframe } = this.state;
    
    const { Option } = Select;

    return (
      <div className="items">
        
        <Layout>

          <Header style={{height: 'auto'}}>
            <div className="site-header">
              <div className="bg-base">
                <div className="bg-background"></div>
                <div className="bg-foreground">
                  <div className="bg-header">
                    <PageHeader
                      title={<><img src="./images/dlt_logo.png" alt="DLT Explorer" height="60" /> Explorer</>}
                      style={{padding:'6px 15px'}}
                      extra={
                        <>
                          <span className="display-options-result"><strong>{currentItems.length}</strong> of <strong>{items.length}</strong></span>
                          <Button.Group style={{marginLeft: 10}}>
                            <Button key="filters" title="View Filters" type="secondary" onClick={e => this.setState({filtersVisible: true})}><strong>Filters</strong></Button>
                            <Button key="clear-filters" icon={<ClearOutlined />} title="Clear filters" type="outline" onClick={this.handleResetFilters} disabled={currentFilters.length <= 0}></Button>
                          </Button.Group>
                          { 
                            inIframe && (
                              <Button.Group style={{marginLeft: 10}}>
                                <Button key="fullscreen" type="outline" title="Open in new window" icon={<ArrowsAltOutlined />} onClick={e => window.open(document.location.href) }/>
                              </Button.Group>
                            ) 
                          }
                        </>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </Header>

          <Content className="site-content" style={{padding:15, marginTop: 80, marginBottom: 30}}>
            <Row gutter={[15,15]}>
              {this.renderItems()}
            </Row>
            <Modal title={currentItem?.title + " Sample"} visible={currentItem != null} onCancel={this.handleHidePreview} width={"90%"} footer={null} style={{top:10}} maskClosable={true}>
              <div className="iframe-container" dangerouslySetInnerHTML={{__html: this.state.currentItem?.description}}></div>
            </Modal>
          </Content>

          <Footer className="footer">
            <div className="footer-contents">
              <Row gutter={8}>
                <Col sm={20}>
                  <div className="hub-promo">
                    Check out the <strong><a href="https://lf.westernsydney.edu.au/engage/" title="Online Engagement and Teaching Hub" target="_blank" rel="noreferrer">The Hub</a></strong> for more resources
                  </div>
                </Col>
                <Col sm={4}>
                  <div className="version">
                    v{process.env.REACT_APP_VERSION}
                  </div>
                </Col>
              </Row>
            </div>
          </Footer>
        </Layout>

        <Drawer
          title={null}
          placement="top"
          closable={true}
          onClose={e => this.setState({filtersVisible: false})}
          visible={filtersVisible}
          height={'auto'}
          mask={true}
          className="drawer-footer"
        >
          <div className="display-options">
            <Row>
              <Col className="display-options-heading">
                <h3>Filters</h3>
              </Col>
              <Col className="display-options-subheading">
                <strong>Showing: {currentItems.length}</strong> of <strong>{items.length}</strong>
              </Col>
            </Row>
          </div>

          <div className="filters">
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <div className="filter-set">
                    <h3><ImLocation className="subheading-icon" /> Cortex Locations{' '}
                      <Tooltip title={
                        <>
                          Cortex items applicable to each Threshold.
                        </>
                      }>
                        <QuestionCircleOutlined className="icon-smaller" />
                      </Tooltip>
                    </h3>
                      {this.renderLocationMenu()};
                  </div>
                </Col>

                <Col xs={24} md={12}>
                  <div className="filter-set">
                    <h3><BiTargetLock className="subheading-icon" /> Focus {' '}
                      <Tooltip title="Filter by focus type">
                        <QuestionCircleOutlined className="icon-smaller" />
                      </Tooltip>
                    </h3>
                    <Select disabled={!focusFilterEnabled} defaultValue={null} style={{width: '100%'}} onChange={ value => this.handleChangeFilter('focus', value) } value={this.getFilterValue('focus')}>
                      <Option key="all" value={null}>All</Option>
                      <Option key="accessibility" value="Accessibility">Accessibility</Option>
                      <Option key="assessment" value="Assessment">Assessment</Option>
                      <Option key="asynchronous" value="Asynchronous">Asynchronous</Option>
                      <Option key="expectations" value="Expectations">Expectations</Option>
                      <Option key="interaction" value="Interaction">Interaction</Option>
                      <Option key="learning-activities" value="Learning activities">Learning activities</Option>
                      <Option key="learning-design" value="Learning design">Learning design</Option>
                      <Option key="learning-materials" value="Learning materials">Learning materials</Option>
                      <Option key="learning-objectives-outcomes" value="Learning objectives and outcomes">Learning objectives and outcomes</Option>
                      <Option key="media" value="Media">Media</Option>
                      <Option key="metacognition" value="Metacognition">Metacognition</Option>
                      <Option key="orientation" value="Orientation">Orientation</Option>
                      <Option key="synchronous" value="Synchronous">Synchronous</Option>
                      <Option key="technology" value="Technology">Technology</Option>
                    </Select>
                  </div>
                </Col>
              </Row>

          </div>
        </Drawer>

        <BackTop visibilityHeight={50} style={{bottom: 60, right: 30}} />

      </div>
    );
  }

  //UTILS
  getFilterValue = (prop) => {
    const { currentFilters } = this.state;
    const foundFilter = currentFilters.find(f => f.prop === prop);
    if (foundFilter) return foundFilter.values;
    return null;
  }
}